import { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { DoubleBounce } from 'better-react-spinkit';

function CartModal(){
    let [isOpen, setIsOpen] = useState(false);

    function closeModal() {
      setIsOpen(false);
      
    }
  
    function openModal() {
      if(isOpen){
        closeModal();
      } else {
      setIsOpen(true);
      }
    
    }
      
    return <>
             <button
          type="button"
          onClick={openModal} className="flex">
              <div className="relative ">
              <svg
                className="w-8 float-right h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                ></path>
              </svg>
              <span className="rounded-full lg:inline-block top-0 -mx-2 pl-2 pr-2 font-bold text-lg right-0 absolute  text-red-600">
                0
              </span>
            </div>
            
            <div className=" flex-col hidden lg:inline-flex">
              <span className="font-sm ">
                My Cart
              </span>
              <span className="text-gray-100 text-xs"> items:$0.00</span>
              
            </div>
            </button>
                <div className={`${ isOpen ? "" : "hidden"}  bg-white my-12 w-[300px] p-2 shadow-lg border-t-4 border-black z-30 -mx-48 transition duration-500 ease-in absolute`}>
                <p className="text-gray-600 text-center border-b p-1 text-xs">There are no more items in your cart</p>
                <div className="text-sm border-b  flex p-2">
                  <div className="text-gray-600 w-2/3 font-bold  text-left"><span>Total (tax excl.)</span><br></br>Taxes</div>
                  <div className=" text-yellow-500 font-bold text-right"><span>Ghc0.00</span><br></br>Ghc0.00</div>
                </div>
                <div className="p-2">
                <button  type="button"
          onClick={closeModal} className="float-left bg-gray-700 hover:bg-gray-800 text-sm rounded pt-2 pb-2 pr-4 pl-4 text-white">close</button>
                <Link to="/cart"><button className="bg-gray-700 hover:bg-gray-800 text-sm rounded pt-2 pb-2 pr-4 pl-4 text-white">VIEW CART</button></Link>
                </div>
                </div>
                
         
             
              
              
      </>
}

export default CartModal;